"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _breakpoints = _interopRequireDefault(require("../../../globals/styles/breakpoints"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1t6mpa0"
} : {
  target: "e1t6mpa0",
  label: "Wrapper"
})("display:flex;flex-direction:column;width:100%;height:100%;max-height:100%;justify-content:space-between;overflow:inherit;gap:0.5em;@media screen and (max-width: ", _breakpoints.default.medium, "){gap:0em;height:unset;}");